import Live2Leap from "../../components/live2/leap/Live2Leap";
import {useSocket} from "../../helpers/socket";


const Live2LeapPage = () => {
    const {socket} = useSocket({});
    return <Live2Leap socket={socket}/>
}

export default Live2LeapPage;